import ImgCode from '@/components/enroll/ImgCode.vue'
import enrollMixin from '@/components/enroll/enrollMixin.js'
import { NPOST } from '@/utils/net-work'

export default {
  name: 'behavior',
  mixins: [enrollMixin],
  components: {
    ImgCode
  },
  data() {
    return {
      captcha: '',
      // 图形验证码
      imgCodeSrc: '',
      // 前端生成token
      token: '',
      // 显示状态
      behaviorVisible: false
    }
  },
  computed: {
    // 确定按钮能否点击
    confirmUsable() {
      return this.code
    },
    // 验证码弹窗状态
    getBhehaviorStaus() {
      return this.$store.state.behaviorStatus
    }
  },
  watch: {
    getBhehaviorStaus() {
      // 重置弹窗状态
      if (!this.behaviorVisible) {
        this.getNewCode()
      }
      this.behaviorVisible = true
    }
  },
  methods: {
    // 图形验证码
    getNewCode() {
      this.getNewImageCode()
    },
    getNewImageCode() {
      try {
        this.token = String(new Date().getTime()) + Math.random()
        this.imgCodeSrc = location.origin + '/api/auth/captcha?captcha_token=' + this.token
      } catch (e) {
        this.token = String(new Date().getTime()) + Math.random()
        this.imgCodeSrc = location.origin + '/api/auth/captcha?captcha_token=' + this.token
      }
    },
    // 点击确定
    onConfirm() {
      this.imgCodeValid()
    },
    // 校验图形验证码
    async imgCodeValid() {
      if (!this.code) {
        this.code_error = '请输入正确的图形验证码'
        return false
      }
      try {
        const { success, error } = await NPOST('/api/auth/validate_captcha', {
          // 图形验证码
          captcha: this.code,
          // 前端随机签名
          captcha_token: this.token
        })
        // 验证失败重新刷新验证码
        if (!success) {
          this.code_error = error
          this.getNewImageCode()
          return true
        } else {
          this.behaviorVisible = false
          window.location.reload()
        }
      } catch (err) {
        console.log(error)
      }
    },
    onCancel() {
      this.behaviorVisible = false
    }
  }
}
